export const ubcReportIssueForm =
    'https://docs.google.com/forms/d/1aPhBKcCseiP84Z_U4DqqzFh_VHpdpBpUxXrK9hqQeag/edit?ts=6450991e'
